import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  html: [
    {
      html: "",
    },
  ],

  template: [
    {
      templateName: "temp1",
    },
  ],

  userTemplateName: [
    {
      userTemplateName: "Template",
    },
  ],

  savedTemplate: [
    {
      templateName: [],
    },
  ],
};

export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    saveHtml: (state, action) => {
      if (action.payload !== "") {
        const html = action.payload;

        state.html = [];
        state.html = [...state.html, { html }];
      } else {
        state.html = [];
        state.html = [...state.html, initialState.html[0]];
      }
    },

    templateDetails: (state, action) => {
      const templateName = action.payload;

      // console.log(templateName);
      state.template = [];
      state.template = [...state.template, { templateName }];
    },

    userTemplateDetails: (state, action) => {
      if (action.payload !== "") {
        const userTemplateName = action.payload;

        state.userTemplateName = [];
        state.userTemplateName = [
          ...state.userTemplateName,
          { userTemplateName },
        ];
      } else {
        state.userTemplateName = [];
        state.userTemplateName = [
          ...state.userTemplateName,
          initialState.userTemplateName[0],
        ];
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { saveHtml, templateDetails, userTemplateDetails } =
  templateSlice.actions;

export default templateSlice.reducer;
